import { render } from "./CrearExperimentos.vue?vue&type=template&id=5967f1cb&scoped=true"
import script from "./CrearExperimentos.vue?vue&type=script&lang=js"
export * from "./CrearExperimentos.vue?vue&type=script&lang=js"

import "./CrearExperimentos.vue?vue&type=style&index=0&id=5967f1cb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5967f1cb"]])

export default __exports__